import { ChatAttachment, DraftAttachment } from 'types/Chat'

const toChatAttachment = ({ id, file }: DraftAttachment): ChatAttachment => ({
  id,
  name: file.name,
  size: file.size,
  type: file.type,
})

export { toChatAttachment }
